import { render, staticRenderFns } from "./UPC.vue?vue&type=template&id=6ddcc45b"
import script from "./UPC.vue?vue&type=script&lang=js"
export * from "./UPC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports